import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  BriTeammateAuthorizationModule,
  BriTeammateAuthorizationService,
} from '@davita/bridge-utility-library/authorization';
import { AuthorizationConfig } from '@davita/bridge-utility-library/authorization/authorization-config';
import {
  BriTeammateHttpInterceptor,
} from '@davita/bridge-utility-library/core';
import { AuthErrorInterceptor } from './interceptors/auth-error.interceptor';
import { LoadingInterceptor } from './interceptors/loading.interceptor';

import { FetchRequestor, Requestor } from '@openid/appauth';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { HomeComponent } from './home/home.component'; 
import { BriTeammateLoginModule } from '@davita/bridge-utility-library/login';
import { PatientSearchTableComponent } from './patient-search-table/patient-search-table.component';
import { MatTableModule } from '@angular/material/table';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { PatientDemographicsComponent } from './patient-details/patient-demographics/patient-demographics.component';
import { PatientDetailsComponent } from './patient-details/patient-details.component';
import { PatientDetailsSharedModule } from './patient-details/patient-details-shared.module';
export const AUTHORIZATION_TEAMMATE_CONFIG = <AuthorizationConfig>{};
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import { TeammateSearchComponent } from './teammate-search/teammate-search.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PingOneModalComponent } from './patient-details/pingone-modal/pingone-modal.component';
import { TeammateFacilityRolesComponent } from './teammate-search/teammate-facility-roles/teammate-facility-roles.component';
import { TeammateInformationComponent } from './teammate-search/teammate-information/teammate-information.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { RecentSearchesComponent } from './recent-searches/recent-searches.component';
import { APP_CONFIG, BriAppConfig, BriAuthTeammate } from '@davita/bridge-library/shared';
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';
import { LoadingService } from './services/loading.service';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PatientSearchTableComponent,
    PatientDetailsComponent,
    PatientDemographicsComponent,
    TeammateSearchComponent,
    TeammateFacilityRolesComponent,
    TeammateInformationComponent,
    NotAuthorizedComponent,
    RecentSearchesComponent,
    PingOneModalComponent,
    LoginWrapperComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BriTeammateLoginModule,
    BriTeammateAuthorizationModule.forRoot(environment.authorization.teammate),
    HttpClientModule,
    PatientDetailsSharedModule,
    MatTableModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatTabsModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: BriTeammateHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: Requestor, useValue: new FetchRequestor() }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
